<template>
    <div>
        <app-auction-navigation></app-auction-navigation>
        <div class="container">
            <p class="is-size-4 has-text-centered">Japanese brands</p>
            <app-top-brand-container v-bind:brandCategory="'Japan'"></app-top-brand-container>
            <p class="is-size-4 has-text-centered">Foreign brands</p>
            <app-top-brand-container></app-top-brand-container>
        </div>

        <hr>
        <div class="container">
            <p class="is-size-4 has-text-centered">ALL BRANDS</p>
            <app-simple-brand-container v-for="(brandLabel, index) in getBrandLabels()"
                                        v-bind:label="brandLabel" :key="index">
            </app-simple-brand-container>
        </div>
    </div>
</template>

<script>
    import TopBrandContainer from './TopBrandContainer'
    import BrandContainer from './BrandContainer'
    import AuctionNavigation from './../AuctionNavigation'
    export default {
        components: {
            appTopBrandContainer: TopBrandContainer,
            appSimpleBrandContainer: BrandContainer,
            appAuctionNavigation: AuctionNavigation
        },
        methods: {
            getBrandLabels() {
                return this.$store.getters.getBrandLabels
            }
        },
        mounted () {
            this.$store.dispatch('setQueryToDefault')
            this.$store.dispatch('changeActiveElement')
            this.$store.dispatch('changeModelSearchValue')
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Brand/AuctionBrands.vue